import React, { useState } from "react";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import PersonAdd from "@mui/icons-material/PersonAdd";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { ADMIN_SERVER_BASE_URL, apiClient } from "../util/apiClient";
import { useDispatch, useSelector } from "react-redux";
import { setGoToDashbord, setGoToParameter, setGoToTirage, setUserLoggedIn } from "../store/appSlice";
import SettingsIcon from '@mui/icons-material/Settings';
import { IReduxState } from "../store";
import AppsIcon from '@mui/icons-material/Apps';
import { userHasRight } from "../util/functions";
import PersonIcon from '@mui/icons-material/Person';
import MyDialogComponent from "../components/Common/MyDialogComponent";
import EditUser from "./EditUser";
import { IUserConnected, setUserConnected } from "../store/userSlice";
import AcUnitIcon from '@mui/icons-material/AcUnit';
import DashboardIcon from '@mui/icons-material/Dashboard';



export default function UserAccunt() {
  //Redux
  const dispatch = useDispatch()
  const goToParameter = useSelector((state: IReduxState) => state.application.goToParameter);
  const goToTirage = useSelector((state: IReduxState) => state.application.goToTirage);
  const goToDashbord = useSelector((state: IReduxState) => state.application.goToDashbord);
  const { userConnected } = useSelector((state: IReduxState) => state.users);



  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openDialog, setOpenDialog] = useState(false)
  const [user, setUser] = useState<any>()


  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDeconnexion = (e: any) => {
    e.preventDefault()
    dispatch(setUserLoggedIn(false))
  };

  const handleParameter = (e: any) => {
    e.preventDefault()
    dispatch(setGoToParameter(!goToParameter))
  };

  const handleTirage = (e: any) => {
    e.preventDefault()
    dispatch(setGoToTirage(!goToTirage))
  };

  const handleShowDashbord = (e: any) => {
    e.preventDefault()
    dispatch(setGoToDashbord(!goToDashbord))
  };


  ////////////////////////////// edit /////////////////////////////
  const handleOpenDialog = (e: any) => {
    e.preventDefault()
    setUser(userConnected?.user)
    setOpenDialog(true)
  }

  const handleCloseDialog = (e: any) => {
    e.preventDefault()
    setOpenDialog(false)
  }

  const handleEdit = async (e: any) => {
    try {
      e.preventDefault()
      const apiPayload = { ...user }
      const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/tablesystem/modifierUser", apiPayload)
      if (res.status === 1) {
        const userUpdated: any = { ...userConnected, user: user }
        dispatch(setUserConnected(userUpdated))
        handleCloseDialog(e)
      } else {
        console.log("status !==1")
      }

    } catch (error) {
      console.log("🚀 ~ file: index.tsx:85 ~ handleEdit ~ error:", error)
    }
  };



  return (
    <React.Fragment>
      <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        <Tooltip title="Déconnexion">
          <IconButton
            onClick={handleClick}
            size="small"
            // sx={{ ml: 2 }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <AccountCircleIcon style={{ color: "#ffff" }} />
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem onClick={handleShowDashbord}>
          <ListItemIcon>
            <DashboardIcon fontSize="small" />
          </ListItemIcon>
          Tableau de bord
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleOpenDialog}>
          <ListItemIcon>
            <PersonIcon fontSize="small" />
          </ListItemIcon>
          Profil
        </MenuItem>
        <Divider />
        {userHasRight("MOD06")
          ? (goToParameter
            ? (<MenuItem onClick={handleParameter}>
              <ListItemIcon>
                <AppsIcon fontSize="small" />
              </ListItemIcon>
              Application
            </MenuItem>)
            : (<MenuItem onClick={handleParameter}>
              <ListItemIcon>
                <SettingsIcon fontSize="small" />
              </ListItemIcon>
              Paramètre
            </MenuItem>))
          : ""
        }
        <Divider />
        <MenuItem onClick={handleTirage}>
          <ListItemIcon>
            <AcUnitIcon fontSize="small" />
          </ListItemIcon>
          Tirage
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleDeconnexion}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Se déconnecter
        </MenuItem>
      </Menu>
      <MyDialogComponent
        dialogTitle={`Editer`}
        dialogContent={
          <EditUser
            user={user}
            setUser={setUser}
          />
        }
        handleSave={handleEdit}
        openDialog={openDialog}
        handleOpen={handleOpenDialog}
        handleClose={handleCloseDialog}
        hidButton={true}
      />
    </React.Fragment>
  );
}
